import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {Calendar} from 'primereact/calendar';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {Button} from 'primereact/button';
import {Link, useLocation} from 'react-router-dom';
import appStore from '../../storage/AppStore';
import clubStore from '../../storage/ClubStore';
import Select from '../../ui/Select';
import Btn from '../../ui/Btn';
import MemberSearch from './MemberSearch';
import PageLayout from '../PageLayout';
import NumericPagination from '../NumericPagination';
import './../../common/autocomplete.css';

const Attendance = () => {
  const location = useLocation();
  const query = clubStore.attendance.query;
  const months = clubStore.getLastThreeMonths();

  useEffect(() => {
    clubStore.getTeams();
  }, []);

  useEffect(() => {
    query.setProperty('page_number', 1);
    clubStore.attendance.search();
  }, [location.pathname]);

  const search = () => {
    query.setProperty('page_number', 1);
    clubStore.attendance.search();
  };

  const handleSelectMonth = (year, monthIndex) => {
    const {first, last} = clubStore.getMonthRange(year, monthIndex);
    query.setProperty('date_from', first);
    query.setProperty('date_to', last);
    search();
  };

  const itemTemplate = (member) => (
    <div className="attendance-item">
      <span className="attendance-title">{member.title}</span>
      <Link to={`/manager/trainings/attendance/detail/${member.company_user_id}`} className="attendance-link">
        {member.attended_count}/{member.total_classes}
      </Link>
    </div>
  );

  return (
    <PageLayout
      header={
        <div className="flex justify-content-between align-items-center">
          <h3 className="m-0">{appStore.tr.attendance}</h3>
        </div>
      }
      filters={
        <div className="grid">
          <div className="col-12">
            <div className="attendance-months">
              {months.map(m => (
                <Button key={`${m.year}-${m.monthIndex}`} label={appStore.tr[m.monthName.toLowerCase()]}
                        severity="secondary" outlined
                        onClick={() => handleSelectMonth(m.year, m.monthIndex)}/>
              ))}
            </div>
          </div>

          <div className="col-6 md:col-2">
            <Calendar className="attendance-filter-control" value={query.date_from} maxDate={query.date_to}
                      onChange={e => query.setProperty('date_from', e.value)} dateFormat="dd.mm.yy" showIcon/>
          </div>

          <div className="col-6 md:col-2">
            <Calendar className="attendance-filter-control" value={query.date_to} minDate={query.date_from}
                      maxDate={new Date()} onChange={e => query.setProperty('date_to', e.value)}
                      dateFormat="dd.mm.yy" showIcon/>
          </div>

          <div className="col-12 md:col-3">
            <Select className="attendance-filter-control" label={appStore.tr.team} store={query}
                    prop="team_id" options={clubStore.teams} for_search/>
          </div>

          <div className="col-10 md:col-4">
            <MemberSearch role_id="MMBR" company_id={query.company_id} company_user_id={query.company_user_id}
                          onSelect={value => query.setProperty('company_user_id', value)}/>
          </div>

          <div className="col-2 md:col-1 attendance-search-cell">
            <Btn icon="pi pi-search" severity="info" onClick={search}/>
          </div>
        </div>
      }
      pagination={
        <NumericPagination query={query} onPageChange={page => {
          query.setProperty('page_number', page);
          clubStore.attendance.search();
        }}/>
      }
    >
      <DataTable value={clubStore.attendance.items} emptyMessage={appStore.tr.not_found}>
        <Column field="title" body={itemTemplate}/>
      </DataTable>
    </PageLayout>
  );
};

export default observer(Attendance);